module.exports = __webpack_public_path__ + "prod/1.42.2/img/icon-headphone-white.36987a42.svg";